module.exports = __webpack_public_path__ + "img/logo.a744ee7c.svg";